import projectAPI from '@/api/ProjectAPI'

const state = {
  items: [],
  loadedItem: {}
}

const getters = {
  items (state) {
    return state.items.sort((itemA, itemB) => {
      return itemA.dateModified > itemB.dateModified
    })
  },
  loadedItem (state) {
    return state.loadedItem
  },
  photos (state) {
    return state.photos
  }
}

const actions = {
  list ({ commit }) {
    commit('setLoading', true, { root: true })
    projectAPI.list()
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('setItems', resp.data.projects)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  view ({ commit, dispatch }, id) {
    commit('setLoading', true, { root: true })
    projectAPI.view(id)
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('setLoadedItem', resp.data.tour)
        dispatch('locations/setLocations', resp.data.tour.locations, { root: true })
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  create ({ commit, getters }, payload) {
    commit('setLoading', true, { root: true })
    return new Promise((resolve, reject) => {
      projectAPI.create(payload)
        .then(resp => {
          commit('setLoading', false, { root: true })
          commit('clearError', null, { root: true })
          commit('addItem', resp.data.tour)
          resolve(resp)
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          reject(error)
          console.log(error)
        })
    })
  },
  // update ({ commit }, payload) {
  //   commit('setLoading', true, { root: true })
  //   const updateObj = { id: payload.id }
  //   if (payload.name) {
  //     updateObj.name = payload.name
  //   }
  //   ucordsApi.updateUcord(updateObj)
  //     .then(resp => {
  //       commit('setLoading', false, { root: true })
  //       commit('setItem', resp.data.ucord)
  //     })
  //     .catch(error => {
  //       commit('setLoading', false, { root: true })
  //       commit('setError', error, { root: true })
  //       console.log(error)
  //     })
  // },
  delete ({ commit }, itemId) {
    projectAPI.delete(itemId)
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('delete', itemId)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  }
  // duplicate ({ commit, getters }, payload) {
  //   commit('setLoading', true, { root: true })
  //   console.log(payload)
  //   return new Promise((resolve, reject) => {
  //     const newUcord = { name: payload.name }
  //     ucordsApi.duplicateUcord(payload.id, newUcord)
  //       .then(resp => {
  //         commit('setLoading', false, { root: true })
  //         commit('clearError', null, { root: true })
  //         commit('addItem', resp.data)
  //         resolve(resp)
  //       })
  //       .catch(error => {
  //         commit('setLoading', false, { root: true })
  //         commit('setError', error, { root: true })
  //         reject(error)
  //         console.log(error)
  //       })
  //   })
  // }
}

const mutations = {
  setItems (state, items) {
    state.items = items
  },
  addItem (state, payload) {
    state.items.push(payload)
  },
  setLoadedItem (state, payload) {
    state.loadedItem = payload
  },
  setItem (state, payload) {
    const item = state.items.find(item => {
      return item.id === payload.id
    })
    item.name = payload.name
    item.dateModified = payload.dateModified
    item.isLocked = payload.isLocked
  },
  delete (state, itemId) {
    state.items = state.items.filter(function (item) { return item.id !== itemId })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
